<template>
    <v-dialog
        v-model="editUserNameDialogHandle"
        max-width="600px"
        transition="dialog-bottom-transition"
        @keydown.esc="closeEditUserNameDialog()"
        @click:outside="closeEditUserNameDialog()"
    >
        <v-form @submit.prevent.native="processEditUser()">

            <v-card>
                <v-toolbar
                    :class="dialogHeadingClasses()"
                    color="primary"
                    dark
                >
                    <v-icon class="mr-3" v-text="icons.mdiAccountEdit"></v-icon>
                    {{ $gettext('Edit User') }}
                    <v-spacer></v-spacer>
                    <v-icon class="mr-2" v-text="icons.mdiClose"
                            @click.native.stop="closeEditUserNameDialog()"></v-icon>
                    <v-icon v-text="icons.mdiContentSave" @click.native.stop="processEditUser()"></v-icon>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text class="mt-8">
                    <v-container>
                        <v-row>

                            <v-col cols="12">
                                <v-text-field
                                    v-model="editUserName"
                                    :error-messages="editUserNameErrors"
                                    :label="$gettext('User Name')"
                                    :placeholder="$gettext('User Name')"
                                    autofocus
                                    clearable
                                    outlined
                                    required
                                    @blur="$v.editUserName.$touch()"
                                    @input="$v.editUserName.$touch()"
                                ></v-text-field>

                                <!------------------------------------------------
                                    Login & Password are optional field as of now
                                ------------------------------------------------->

                                <!--                                <v-text-field-->
                                <!--                                    v-model="editLogin"-->
                                <!--                                    :label="$gettext('Login')"-->
                                <!--                                    :placeholder="$gettext('Login')"-->
                                <!--                                    clearable-->
                                <!--                                    outlined-->
                                <!--                                ></v-text-field>-->

                                <!--                                <v-text-field-->
                                <!--                                    v-model="editPassword"-->
                                <!--                                    :label="$gettext('Password')"-->
                                <!--                                    :placeholder="$gettext('Password')"-->

                                <!--                                    clearable-->
                                <!--                                    outlined-->
                                <!--                                ></v-text-field>-->

                            </v-col>

                            <v-col cols="12">
                                <v-autocomplete
                                    v-model="editUserGroup"
                                    :error-messages="editUserGroupErrors"
                                    :items="$props.inEditAllUserGroups"
                                    :label="$gettext('Choose account group')"
                                    clearable
                                    outlined
                                    prepend-inner-icon="mdi-magnify"
                                    required
                                    @blur="$v.editUserGroup.$touch()"
                                    @input="$v.editUserGroup.$touch()"
                                >
                                </v-autocomplete>

                                <v-select
                                    v-model="editProfile"
                                    :error-messages="editProfileErrors"
                                    :items="profiles"
                                    :label="$gettext('Categories Profile')"
                                    :placeholder="$gettext('Categories Profile')"
                                    item-text="profile_name"
                                    item-value="profile_name"
                                    outlined
                                    @blur="$v.editProfile.$touch()"
                                    @input="$v.editProfile.$touch()"
                                >
                                </v-select>

                            </v-col>

                        </v-row>

                    </v-container>

                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions color="secondary">
                    <v-spacer></v-spacer>
                    <v-btn class="primary" @click.native.stop="closeEditUserNameDialog()">
                        {{ $gettext('Close') }}
                    </v-btn>
                    <v-btn class="primary" type="submit">
                        {{ $gettext('Save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>

    </v-dialog>
</template>
<style type="text/scss">
.add-rule-radio-margin .v-input--selection-controls {
    margin-top: 0;
}

</style>

<script>

import Vue from 'vue'
import {find, findIndex, isArray, isString} from 'lodash'

import Vuelidate from 'vuelidate'
import {required} from 'vuelidate/lib/validators'

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinConfigUsers from '@/mixins/database/MixinConfigUsers'
import MixinVuelidate from '@/mixins/MixinVuelidate'
import {useCategoriesStore} from "@/stores/CategoriesStore";
import {mapState, mapWritableState} from "pinia";

Vue.use(Vuelidate)

export default {
    components: {Snackbar},
    mixins: [MixinDialog, MixinIcon, MixinConfigUsers, MixinVuelidate],
    props: {
        editUserNameDialog: {
            required: true,
            type: Boolean,
            default: false
        },
        inEditUserCategoryParent: {
            required: true,
            default: ''
        },
        inEditUserName: {
            required: true,
            default: ''
        },
        inEditAllUserGroups: {
            required: true,
            default: []
        },
        inEditLogin: {
            required: false,
            default: ''
        },
        inEditPassword: {
            required: false,
            default: ''
        },
        inEditProfile: {
            required: true,
            default: ''
        },
    },

    watch: {
        // Mounted only fills in the dialog for the first time, the rest of the time it is filled by the watcher
        editUserNameDialog(newVal) {
            let self = this

            if (newVal) {
                self.prefillFormValues()
            } else {
                self.resetForm()
            }

        }
    },

    mounted() {
        let self = this
        // Mounted only fills in the dialog for the first time, the rest of the time it is filled by the watcher
        self.prefillFormValues()
        self.editUserNameDialogHandle = self.$props.editUserNameDialog
        self.editProfile = self.$props.inEditProfile

    },
    data() {
        return {
            editUserName: '',
            editUserGroup: '',
            editUserNameDialogHandle: '',
            editLogin: '',
            editPassword: '',
            editProfile: '',
        }
    },

    methods: {

        prefillFormValues() {

            let self = this
            self.editUserName = self.$props.inEditUserName
            self.editUserGroup = self.$props.inEditUserCategoryParent
            self.editLogin = self.$props.inEditLogin
            self.editPassword = self.$props.inEditPassword
            self.editProfile = self.$props.inEditProfile

        },

        processEditUser() {

            let self = this
            self.$v.$touch()

            if (!self.$v.$invalid) {

                self.$emit('user-edited', self.$props.inEditUserCategoryParent, self.editUserName, self.editUserGroup, self.editLogin, self.editPassword, self.editProfile)

                self.closeEditUserNameDialog()

            }

        },

        closeEditUserNameDialog() {
            let self = this
            self.$emit('close-edit-user-name-dialog', 'editUserNameDialog')
        },
        resetForm() {
            let self = this
            self.$v.$reset()
            self.editUserName = ''
        },
    },
    computed: {

        editUserNameErrors() {
            const errors = []
            if (!this.$v.editUserName.$dirty) return errors
            !this.$v.editUserName.required && errors.push(this.$gettext('User name is required.'))
            !this.$v.editUserName.isUnique && errors.push(this.$gettext('Sorry! It appears we already have this user name in use.'))
            return errors
        },

        editUserGroupErrors() {
            const errors = []
            if (!this.$v.editUserGroup.$dirty) return errors
            !this.$v.editUserGroup.required && errors.push(this.$gettext('Please choose a user group'))
            return errors
        },

        editProfileErrors () {
            const errors = []
            if ( ! this.$v.editProfile.$dirty) return errors
            ! this.$v.editProfile.required && errors.push(this.$gettext('Categories profile is required'))
            return errors
        },

        ...mapState(useCategoriesStore, {
            profiles: 'profiles'
        })

    },
    validations: {
        editUserName: {
            required,
            isUnique(value, vm) {

                if (value && isString(value) && value.length > 0 && value.toLowerCase() === vm.$props.inEditUserName?.toLowerCase()) {
                    return true
                } else if (isArray(this.consolidatedUsersAndSubUsers) && this.consolidatedUsersAndSubUsers.length > 0) {
                    return (findIndex(this.consolidatedUsersAndSubUsers, (user) => user.toLowerCase() === value.toLowerCase()) === -1)
                }

                return true

            }
        },
        editUserGroup: {
            required
        },
        editProfile: {
            required
        }
    }

}
</script>
